import React, { FC, PropsWithChildren } from 'react';

type TagProps = {
  /** The color of the icon. */
  color?: string;
};

const Tag: FC<PropsWithChildren<TagProps>> = ({ color = 'currentColor' }) => (
  <svg fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M2.61252 1.62602C1.95285 1.72026 1.43454 2.23857 1.34031 2.89823L0.515082 8.6748C0.450355 9.12788 0.596125 9.58572 0.910898 9.91798L8.86838 18.3175C9.44878 18.9302 10.4203 18.9433 11.017 18.3466L18.0609 11.3027C18.6576 10.7059 18.6445 9.73446 18.0318 9.15406L9.63227 1.1966C9.3 0.88183 8.84217 0.73606 8.38908 0.800788L2.61252 1.62602ZM2.32981 3.03959C2.36122 2.8197 2.53399 2.64693 2.75388 2.61552L8.53044 1.79029C8.68147 1.76871 8.83408 1.8173 8.94483 1.92223L17.3444 9.87968C17.5486 10.0732 17.553 10.397 17.3541 10.5959L10.3102 17.6398C10.1113 17.8387 9.78747 17.8343 9.594 17.6301L1.63652 9.23055C1.5316 9.1198 1.48301 8.96718 1.50458 8.81615L2.32981 3.03959ZM8.43859 7.22497C8.43859 8.05302 7.76732 8.72429 6.93927 8.72429C6.11121 8.72429 5.43994 8.05302 5.43994 7.22497C5.43994 6.39692 6.11121 5.72565 6.93927 5.72565C7.76732 5.72565 8.43859 6.39692 8.43859 7.22497ZM9.43813 7.22497C9.43813 8.60506 8.31935 9.72384 6.93927 9.72384C5.55918 9.72384 4.4404 8.60506 4.4404 7.22497C4.4404 5.84489 5.55918 4.7261 6.93927 4.7261C8.31935 4.7261 9.43813 5.84489 9.43813 7.22497Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default Tag;
